#!/usr/bin/env node
import * as commander from 'commander';
import 'dotenv/config';
const pkg = require("../package");
const updateNotifier = require('update-notifier');

const notifier = updateNotifier({
    pkg,
    updateCheckInterval: 1000 * 60 * 60 * 24 // 1 day
});

if (notifier.update) {
    notifier.notify({
        isGlobal: true,
        defer: true
    });
}

commander
    .version(pkg.version)
    .description("porketta.io command line utility")
    .command("vhost <cmd>", "Manage VHost")
    .command("provider <cmd>", "Manage CloudProviders")
    .command("alias <cmd>", "Manage Alias")
    .command("user <cmd>", "Manage account and authentication")
    .command("deploy <service>", "Deploy a pre-configured service on a cloud provider");

if(process.env.STAGE && process.env.STAGE.length > 1) {
    console.log("#####################################");
    console.log(`# STAGE: : ${process.env.STAGE}`.padEnd(36, ' ') + '#');
    console.log("#####################################");
}

commander.parse(process.argv);
if (!commander.args.length) commander.help();